import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  FormHelperText,
} from "@mui/material";
import {
  SaveGeneralLedgerCode,
  UpdateGeneralLedgerCode,
} from "../../../services/BillingMaintenanceService";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../../common/CommonLoader";

const AddEditGLCodeDialog = ({ open, onClose, onSuccess, editGLCode }) => {
  const [glCode, setGlCode] = useState("");
  const [glAccountDescription, setGlAccountDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editGLCode) {
      setGlCode(editGLCode.glCode || "");
      setGlAccountDescription(editGLCode.glAccountDescription || "");
    }
  }, [editGLCode]);

  const validateForm = () => {
    const errors = {};
    if (!glCode.trim()) {
      errors.glCode = "GL Code is required";
    }
    if (!glAccountDescription.trim()) {
      errors.glAccountDescription = "GL Account Description is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoading(true);
      try {
        if (editGLCode) {
          await UpdateGeneralLedgerCode({ glCode, glAccountDescription });
          NotificationManager.success("GL Code updated successfully");
        } else {
          await SaveGeneralLedgerCode({ glCode, glAccountDescription });
          NotificationManager.success("GL Code added successfully");
        }
        handleClose();
        onSuccess();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        NotificationManager.error(
          "An error occurred while saving the GL Code."
        );
      }
    }
  };

  const handleClose = () => {
    setGlCode("");
    setGlAccountDescription("");
    setErrors({});
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {editGLCode ? "Edit GL Code" : "Add New GL Code"}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <FormControl fullWidth margin="normal" error={!!errors.glCode}>
              <TextField
                label="GL Code"
                value={glCode}
                onChange={(e) => setGlCode(e.target.value)}
              />
              {errors.glCode && (
                <FormHelperText>{errors.glCode}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              margin="normal"
              error={!!errors.glAccountDescription}
            >
              <TextField
                label="GL Account Description"
                value={glAccountDescription}
                onChange={(e) => setGlAccountDescription(e.target.value)}
              />
              {errors.glAccountDescription && (
                <FormHelperText>{errors.glAccountDescription}</FormHelperText>
              )}
            </FormControl>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button type="submit" variant="contained" color="primary">
                Save
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <CommonLoader loading={loading} />
    </>
  );
};

export default AddEditGLCodeDialog;
